<!--  -->
<template>
  <div class="ProductList">
    <div class="product-main">
      <div class="product-select">
        <ul class="product-ul">
          <li
            v-for="(item, index) in productList"
            :key="index"
            @click="changeProduct(item.id, index)"
            :class="{ active: item.id == currentShow }"
          >
            <div class="product-logo">
              <img :src="item.pic_f" />
            </div>
            <h1>{{ item.title }}</h1>
          </li>
        </ul>
        <router-link :to="lingchuang.url" v-if="beimeiShow">
          <div class="clinic">
            <div class="lingchuang-box">
              <img :src="lingchuang.pic_f" />
            </div>
            <h1>{{ lingchuang.title }}</h1>
          </div>
        </router-link>
      </div>

      <ul class="product-classify" v-if="showmore">
        <li v-for="(item, index) in productList" :key="index">
          <div class="classify-box">
            <img class="imgControl" :src="item.pic_bg" />
          </div>
          <div class="classify-title">
            <h1>{{ item.title }}</h1>
            <div class="look-more" @click="changeProduct(item.id)">
              <span>{{ lookmore }}</span>
            </div>
          </div>
        </li>
      </ul>

      <div class="lingchuang-list" v-if="showmore" v-show="beimeiShow">
        <h1>{{ lingchuang.title }}</h1>
        <router-link :to="lingchuang.url">
          <div class="look-more">
            <span>{{ lookmore }}</span>
          </div>
        </router-link>
      </div>

      <ul class="Details-list" v-if="productdetails.length > 0">
        <li class="Details-title">
          <div class="title-text">
            <h1>{{ class_name }}</h1>
            <!-- <p>{{ class_intro }}</p> -->
          </div>
          <div class="title-img">
            <img :src="class_pic_bg" />
          </div>
        </li>
        <li
          class="Details-more"
          v-for="(item, index) in productdetails"
          :key="index"
        >
          <div class="product-img">
            <img :src="item.src" />
          </div>
          <div class="product-text">
            <h1>{{ item.title }}</h1>
            <!-- <p>
              {{ item.msg }}
            </p> -->
            <router-link :to="item.url"
              ><div class="lookmore">{{ lookmore }}</div></router-link
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      isshow: 0, //地区0国外,1中国
      class_name: "",
      class_intro: "",
      class_pic_bg: "",
      productList: [
        /* 
        {
          title: "导航类产品",
          src: require("../../assets/navproductbg.png"),
        },
        {
          title: "导航平台",
          src: require("../../assets/navproductbg.png"),
        },
        {
          title: "治疗平台",
          src: require("../../assets/navproductbg.png"),
        },
       */
      ],
      lingchuang: {
        id: 0,
        title: "",
        pic_f: "",
        url: "",
      },
      lookmore: "", //了解更多
      currentShow: false,
      productdetails: [],
      showmore: true,
      queryUrl: "",
      beimeiShow: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    $route(to, from) {
      this.currentShow = parseInt(this.$route.query.cid);

      console.log(this.currentShow);
      if (this.currentShow != "") {
        this.changeProduct(this.currentShow);
      }
    },
  },
  //方法集合
  methods: {
    //1.得到地区
    get_nav() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        async: false,
        data: {
          act: "get_nav",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            if (obj.region) {
              if (parseInt(obj.region) > 0) that.isshow = 0;
              else that.isshow = 1;
            } else {
              that.isshow = 1;
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.得到产品分类n+1
    get_class() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_two_class",
          id: 4,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            $.each(obj.data, function (i, k) {
              if (obj.region == 2) {
                if (i < obj.data.length - 1) {
                  that.productList.push({
                    id: k.id,
                    title: k.title,
                    pic_f: k.pic_f,
                    pic_bg: k.pic_bg,
                  });
                } else if (i == obj.data.length);
                {
                  that.lingchuang.title = obj.data[i].id;
                  that.lingchuang.title = obj.data[i].title;
                  that.lingchuang.pic_f = obj.data[i].pic_f;
                  that.lingchuang.url = obj.data[i].url;
                }
              } else {
                if (i < obj.data.length - 1) {
                  if (k.id == "12") {
                    //第1个【导航产品】如果是国内则用默认图片
                    var pic_bg = k.pic_bg;
                    if (that.isshow == 1)
                      pic_bg = "/Uploads/Product/dh_bg_cn.png"; //国内
                    if (obj.region == 3)
                      pic_bg = "/Uploads/Product/dh_bg_cn.png";
                    that.productList.push({
                      id: k.id,
                      title: k.title,
                      pic_f: k.pic_f,
                      pic_bg: pic_bg,
                    });
                  } else if (k.id == "13") {
                    //第2个【诊断产品】如果是国内则用默认图片
                    var pic_bg = k.pic_bg;
                    if (that.isshow == 1)
                      pic_bg = "/Uploads/Product/zd_bg_cn.png";
                    if (obj.region == 3)
                      pic_bg = "/Uploads/Product/zd_bg_cn.png";
                    if (obj.region == 1 || obj.region == 2)
                      pic_bg = "/Uploads/Product/zd_bg_en.png"; //国内
                    that.productList.push({
                      id: k.id,
                      title: k.title,
                      pic_f: k.pic_f,
                      pic_bg: pic_bg,
                    });
                  } else if (k.id == "14") {
                    //第3个【治疗产品】如果是国内则用默认图片
                    var pic_bg = k.pic_bg;
                    if (that.isshow == 1)
                      pic_bg = "/Uploads/Product/zl_bg_cn.png"; //国内
                    that.productList.push({
                      id: k.id,
                      title: k.title,
                      pic_f: k.pic_f,
                      pic_bg: pic_bg,
                    });
                  }
                } else if (i == obj.data.length);
                {
                  that.lingchuang.title = obj.data[i].id;
                  that.lingchuang.title = obj.data[i].title;
                  that.lingchuang.pic_f = obj.data[i].pic_f;
                  that.lingchuang.url = obj.data[i].url;
                }
              }
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //3.得到分类下数据
    changeProduct(val) {
      const that = this;
      that.currentShow = val;
      that.showmore = false;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: val,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.class_name = obj.yj_name;
            that.class_intro = obj.yj_description;
            that.class_pic_bg = obj.yj_pic_f;

            if (that.isshow == 1) {
              //国内
              if (val == "12")
                that.class_pic_bg = "/Uploads/Product/dh_list_cn.png";
              if (val == "13")
                that.class_pic_bg = "/Uploads/Product/zd_list_cn.png";
              if (val == "14")
                that.class_pic_bg = "/Uploads/Product/zl_list_cn.png";
            }

            if (that.isshow == 0) {
              if (obj.region == 1 || obj.region == 2) {
                if (val == "12")
                  that.class_pic_bg = "/Uploads/Product/dh_list_en.png";
                if (val == "13")
                  that.class_pic_bg = "/Uploads/Product/zd_list_en.png";
                if (val == "14")
                  that.class_pic_bg = "/Uploads/Product/zl_list_en.png";
              } else {
                if (val == "12")
                  that.class_pic_bg = "/Uploads/Product/dh_list_cn.png";
                if (val == "13")
                  that.class_pic_bg = "/Uploads/Product/zd_list_cn.png";
                if (val == "14")
                  that.class_pic_bg = "/Uploads/Product/zl_list_cn.png";
              }
            }

            that.productdetails = [];
            $.each(obj.data, function (i, k) {
              that.productdetails.push({
                id: k.id,
                title: k.title,
                src: k.pic_f,
                msg: k.description,
                url: "/goodsdetails?id=" + k.id,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.lookmore = obj.data["ljgd"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.get_nav();
    this.get_class();
    this.get_fanyi();
    this.currentShow = parseInt(this.$route.query.cid);
    console.log(this.currentShow);
    if (this.$route.query.cid == "") {
      this.changeProduct(this.currentShow);
    }

    var v = parseUrl();
    if (v["cid"] != "") {
      if (this.currentShow != "") {
        this.changeProduct(this.currentShow);
      }
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};

function parseUrl() {
  var url = location.href;
  var i = url.indexOf("?");
  if (i == -1) return;
  var querystr = url.substr(i + 1);
  var arr1 = querystr.split("&");
  var arr2 = new Object();
  for (i in arr1) {
    var ta = arr1[i].split("=");
    arr2[ta[0]] = ta[1];
  }
  return arr2;
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.ProductList {
  width: 100%;
  margin-bottom: 40px;
  .product-main {
    width: $main-width;
    margin: 0 auto;
    .product-select {
      display: flex;
      justify-content: space-between;
      .product-ul {
        display: flex;
        // justify-content: space-between;
        li {
          width: 227px;
          min-height: 186px;
          position: relative;
          background: #eeeeee;
          border-radius: 11px;
          padding: 14px;
          margin-right: 26px;
          cursor: pointer;
          transition: 0.3s;
          .product-logo {
            width: 100%;
            text-align: right;
          }
          h1 {
            position: absolute;
            bottom: 10px;
            margin-left: 10px;
            font-size: 1.15rem;
            color: #666;
          }
        }
        .active {
          background: #ffc85a;
          overflow: hidden;
          img {
            transform: translateY(-1350px);
            filter: drop-shadow(0px 1350px #fff);
          }
          h1 {
            color: #ffffff;
          }
        }
      }
      .clinic {
        width: 227px;
        height: 100%;
        background: #eeeeee;
        border-radius: 10px;
        padding: 25px 34px;
        position: relative;
        .lingchuang-box {
          width: 100%;
          text-align: right;
        }
        h1 {
          position: absolute;
          bottom: 10px;
          margin-top: 15px;
          font-size: 1.1rem;
          color: #666;
        }
      }
    }
    .product-classify {
      display: flex;
      flex-direction: column;
      li {
        margin-top: 50px;
        width: 100%;
        height: 391px;
        display: flex;
        .classify-box {
          width: 66.6%;
          height: 100%;
        }
        .classify-title {
          width: 33.4%;
          height: 100%;
          background: #0a7ec1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          h1 {
            font-size: 1.8rem;
            color: #fff;
          }
          .look-more {
            cursor: pointer;
            margin-top: 40px;
            border: 1px solid #fafafa;
            border-radius: 24px;
            padding: 6px 20px;
            span {
              font-size: 1.2rem;
              color: #fff;
            }
          }
        }
      }
      li:nth-child(even) {
        flex-direction: row-reverse;
      }
      li:nth-child(2n) .classify-title {
        background-color: #2b3788;
      }
      li:nth-child(3n) .classify-title {
        background-color: #8553a2;
      }
    }
    .lingchuang-list {
      margin: 50px 0 100px;
      width: $main-width;
      height: 360px;
      background: #47aeea;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        font-size: 1.8rem;
        color: #fff;
      }
      .look-more {
        cursor: pointer;
        margin-top: 40px;
        border: 1px solid #fafafa;
        border-radius: 24px;
        padding: 6px 20px;
        span {
          font-size: 1.2rem;
          color: #fff;
        }
      }
    }
    .Details-list {
      width: $main-width;
      margin: 50px auto;
      .Details-title {
        width: 100%;
        height: 390px;
        background: #f2f2f2;
        display: flex;
        justify-content: space-around;
        padding: 12px 0;
        .title-text {
          width: 50%;
          height: 100%;
          padding: 40px 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          h1 {
            font-size: 2.4rem;
            color: #193b95;
            font-weight: 600;
          }
          p {
            margin-top: 40px;
            font-size: 1.1rem;
            color: #333;
            line-height: 2;
          }
        }
        .title-img {
          width: 546px;
          height: 369px;
          img {
            width: 100%;
          }
        }
      }
      .Details-more {
        width: 100%;
        height: 350px;
        margin-top: 30px;
        display: flex;
        .product-img {
          width: 59%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .product-text {
          width: 41%;
          height: 100%;
          background: #b8afca;
          padding: 52px 57px 0;
          h1 {
            text-align: center;
            font-size: 2rem;
            color: #302b80;
            margin: 80px auto 0;
          }
          p {
            margin-top: 30px;
            font-size: 1.1rem;
            color: #333;
            font-weight: 200;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
          }
          .lookmore {
            margin: 20px auto 0;
            width: 50%;
            border-radius: 24px;
            background: #8553a2;
            color: #fff;
            font-size: 1rem;
            padding: 10px 20px;
            text-align: center;
          }
        }
      }
      .Details-more:nth-child(even) {
        flex-direction: row-reverse;
      }
    }
  }
}
@media screen and (max-width: $main-width) {
  .ProductList {
    .product-main {
      width: 100%;
      .product-select {
        flex-wrap: wrap;
        .product-ul {
          flex-wrap: wrap;
          justify-content: center;
          li {
            margin: 10px auto;
            width: 90%;
            min-height: 176px;
            h1 {
              width: 35%;
              font-size: 1.6rem;
              top: 40%;
            }
          }
        }
        .clinic {
          width: 90%;
          margin: 10px auto;
        }
      }

      .product-classify {
        li {
          padding: 0 10px;
          height: auto;
          flex-direction: column;
          .classify-box {
            width: 100%;
          }
          .classify-title {
            width: 100%;
            padding: 20px 0;
          }
        }
        li:nth-child(even) {
          flex-direction: column;
          .classify-box {
            width: 100%;
          }
          .classify-title {
            width: 100%;
          }
        }
      }

      .lingchuang-list {
        width: 100%;
      }

      .Details-list {
        width: 100%;
        .Details-title {
          height: auto;
          flex-direction: column;
          .title-text {
            width: 100%;
            padding: 20px 10px;
            p {
              margin-top: 20px;
            }
          }
          .title-img {
            width: 100%;
            height: auto;
            padding: 0 10px;
          }
        }

        .Details-more:nth-child(even) {
          justify-content: center;
          flex-direction: column;
        }
        .Details-more {
          height: auto;
          display: flex;
          justify-content: center;
          flex-direction: column;
          .product-img {
            width: 100%;
            height: auto;
            padding: 0 10px;
          }
          .product-text {
            width: 100%;
            padding: 40px 10px;
            h1 {
              margin-top: 20px;
            }
            .lookmore {
              width: 50%;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/ProductList.vue